import React from "react";
import Acadamic from "../../../assest/academic_observation.png";
import Behaviour from "../../../assest/behaviour_observation.png";
import { useParams } from "react-router-dom";

const Progresslanguage = ({
  Language_list,
  Language_option,
  setLanguage_option,
}) => {
  const { id, type, child_id, qtype } = useParams();

  return (
    <div className="w-full h-[10%] flex items-center justify-center max-[740px]:hidden">
      {/* PROGRESS START */}
      <div className="w-7/12">
        <div className="w-full flex items-center justify-center">
          <div className="flex items-center justify-center">
            <div className="w-12 bg-[#f8dbc0] flex items-center justify-center p-2 rounded-full border-2 border-[#f79221] relative">
              <img src={Acadamic} className="w-full" alt="" />
              <p className="absolute text-xs w-48 top-full  pt-1 font-semibold text-center max-[750px]:left-[-50%]">
                Academic Observation
              </p>
            </div>
          </div>
          <div className="w-6/12 h-2 bg-[#f8dbc0]">
            <span
              className={`h-full w-${
                qtype == 1 ? "6" : "12"
              }/12 bg-[#f79221] block`}
            ></span>
          </div>
          <div className="flex items-center justify-center">
            <div
              className={`w-12  flex items-center justify-center p-2 rounded-full border-2 ${
                qtype == 1
                  ? "border-[#757575] bg-[#f4f4f4] grayscale"
                  : "border-[#f79221] bg-[#f8dbc0]"
              }   relative`}
            >
              <img src={Behaviour} className="w-full" alt="" />
              <p className="absolute text-xs w-48 top-full  pt-1 font-semibold text-center max-[750px]:right-[-50%]">
                Behaviour Observation
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* PROGRESS END */}
      {/* LANGUAGE START */}
      <div className="w-5/12 flex justify-center">
        <div className="bg-[#ccc6] py-2 px-3 rounded">
          <label
            htmlFor="selectlang1"
            className="font-semibold text-[#0009] mr-2 text-xs"
          >
            Language :
          </label>
          <select
            name="selectlang1"
            id="selectlang1"
            value={Language_option}
            className="outline-0 font-semibold bg-[transparent] text-sm"
            onChange={(e) => setLanguage_option(e.target.value)}
          >
            {Language_list?.map((item, index) => {
              return (
                <option key={index} value={item?.id}>
                  {item?.language_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {/* LANGUAGE END */}
    </div>
  );
};

export default Progresslanguage;
